import { render, staticRenderFns } from "./MonitoringReportGeneral.vue?vue&type=template&id=48d9edd3"
import script from "./MonitoringReportGeneral.vue?vue&type=script&lang=js"
export * from "./MonitoringReportGeneral.vue?vue&type=script&lang=js"
import style0 from "./MonitoringReportGeneral.vue?vue&type=style&index=0&id=48d9edd3&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d9edd3')) {
      api.createRecord('48d9edd3', component.options)
    } else {
      api.reload('48d9edd3', component.options)
    }
    module.hot.accept("./MonitoringReportGeneral.vue?vue&type=template&id=48d9edd3", function () {
      api.rerender('48d9edd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MonitoringReport/MonitoringReportGeneral.vue"
export default component.exports